export default "__VITE_ASSET__hLbyNnXL__"